// Транслитерация имён под язык интерфейса: «Анатолий» → Anatoliy (en/es/de/ar),
// John → «Джон» (ru). Это транслитерация, не перевод: фамилии и редкие имена
// передаются «как слышится». Строки с '@' не трогаем — это идентификаторы.
const RU2LAT = {
  а:'a', б:'b', в:'v', г:'g', д:'d', е:'e', ё:'yo', ж:'zh', з:'z', и:'i', й:'y',
  к:'k', л:'l', м:'m', н:'n', о:'o', п:'p', р:'r', с:'s', т:'t', у:'u', ф:'f',
  х:'kh', ц:'ts', ч:'ch', ш:'sh', щ:'shch', ъ:'', ы:'y', ь:'', э:'e', ю:'yu', я:'ya',
};
// Обратный порядок важен: сперва длинные диграфы.
const LAT2RU = [
  ['shch','щ'], ['sch','щ'], ['yo','ё'], ['zh','ж'], ['kh','х'], ['ts','ц'],
  ['ch','ч'], ['sh','ш'], ['yu','ю'], ['ya','я'], ['ph','ф'], ['th','т'],
  ['a','а'], ['b','б'], ['c','к'], ['d','д'], ['e','е'], ['f','ф'], ['g','г'],
  ['h','х'], ['i','и'], ['j','дж'], ['k','к'], ['l','л'], ['m','м'], ['n','н'],
  ['o','о'], ['p','п'], ['q','к'], ['r','р'], ['s','с'], ['t','т'], ['u','у'],
  ['v','в'], ['w','в'], ['x','кс'], ['y','й'], ['z','з'],
];

const hasCyr = (s) => /[а-яё]/i.test(s);
const hasLat = (s) => /[a-z]/i.test(s);

function mapWord(word, toLat) {
  let out = '';
  let i = 0;
  const low = word.toLowerCase();
  while (i < low.length) {
    let hit = null;
    if (toLat) {
      const ch = low[i];
      hit = ch in RU2LAT ? [ch, RU2LAT[ch]] : null;
    } else {
      for (const [src, dst] of LAT2RU) {
        if (low.startsWith(src, i)) { hit = [src, dst]; break; }
      }
    }
    if (!hit) { out += word[i]; i += 1; continue; }
    let [src, dst] = hit;
    // Английская немая h после гласной: John → Джон, Sarah → Сара.
    if (!toLat && src === 'h' && i > 0 && 'aeiou'.includes(low[i - 1])) dst = '';
    // Сохранить заглавную первой буквы фрагмента.
    const isUpper = word[i] !== low[i];
    out += isUpper && dst ? dst[0].toUpperCase() + dst.slice(1) : dst;
    i += src.length;
  }
  return out;
}

/** Имя под язык интерфейса. Не трогает пустые строки и @идентификаторы. */
export function displayName(name, lang) {
  const s = String(name || '');
  if (!s || s.includes('@')) return s;
  if (lang === 'ru') return hasLat(s) && !hasCyr(s) ? mapWord(s, false) : s;
  return hasCyr(s) ? mapWord(s, true) : s;
}
